<template>
	<div>
		<div class="px-3 custom-mobile-left-side-alignment dashboard-mobile-padding-right">
			<div class="row">

				<div class="col-sm-12">
					<div class="row m-b-lg">
						<div class="col-md-12">
							<h4 class="atlhr-dashboard-title mt-10"><span class="blue-title">Hi, {{this.public_info.name}}!</span> <span class="black-title">welcome back!</span><span></span></h4>
							<div>
								<span><span class="dashboard-user-info-key">You Report To: </span><span class="dashboard-user-info-value" v-if="this.public_info.report_to_name">{{public_info.report_to_name}}</span></span>
								<!-- <span class="float-right"><span class="dashboard-user-info-key">Joining Date: </span><span class="dashboard-user-info-value">{{ new Date(this.public_info.date_of_joining).toLocaleDateString("en-US",  { year: 'numeric', month: 'long', day: 'numeric' }) }}</span></span> -->
								 <p class="dashboard-welcome-mobile">
									<span class="float-right ">
										<span class="dashboard-user-info-key">Joining Date: </span>
										<span class="dashboard-user-info-value">
											{{ new Date(this.public_info.date_of_joining).toLocaleDateString("en-US", {
												year: 'numeric', month: 'long', day: 'numeric'
											}) }}
										</span>
									</span>
								</p>
							</div>
						</div>
					</div>
				</div>
                <!-- Abdullah responsive added mt-3 mt-md-0 -->
				<div class="row col-12 no-margin mt-3 mt-md-0 custom-mobile-padding-left-side custom-mobile-padding-right-zero">
					<div class="ibox col-md-12 dashboard-top dashboard-top-alt">
						<div class="ibox-title dashboard_title">
							<h4>Employment Overview</h4>
						</div>
						<div class="ibox-content">
							<div class="row">
								<div class="col-lg-12 col-md-12 col-sm-12">
									<div class="row mb-4">
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Employee Code:</div>
											<div class="time">{{ this.public_info.employee_code }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Mobile Number:</div>
											<div class="time">{{ formatPhoneNumber(this.public_info.phone) }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Gender:</div>
											<div class="time">{{ this.public_info.gender }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Date of Birth:</div>
											<div class="time">{{ this.public_info.date_of_birth }}</div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Job Position:</div>
											<div class="time">{{ this.public_info.jobposition }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Department:</div>
											<div class="time">{{ this.public_info.department }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Work Location:</div>
											<div class="time">{{ this.public_info.branch_name }}</div>
										</div>
										<div class="col-lg-3 col-md-3 col-sm-6">
											<div>Service Period:</div>
											<div class="time">{{ this.public_info.employed_for }}</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="ibox col-md-12 dashboard-top" v-if="addons.includes('LeaveAttendances') && company_access_settings['leave_attendances'] == true">
						<div class="ibox-title dashboard_title">
							<h4>Time and Attendance</h4>
						</div>
						<div class="ibox-content">
							<div class="row">
								<div class="col-lg-9 col-md-9 col-sm-12">
									<div class="row">

										<template v-if="punch_data !== null">
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Clocked in at:</div>
												<div class="time">{{ punch_data.check_in }}</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Clocked out at:</div>
												<div class="time">{{ punch_data.checkout }}</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Break started at:</div>
												<div class="time">N/A</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Break ended at:</div>
												<div class="time">N/A</div>
											</div>
										</template>
										<template v-else>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Clocked in at:</div>
												<div class="time">N/A</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Clocked out at:</div>
												<div class="time">N/A</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Break started at:</div>
												<div class="time">N/A</div>
											</div>
											<div class="col-lg-3 col-md-3 col-sm-6">
												<div>Break ended at:</div>
												<div class="time">N/A</div>
											</div>
										</template>

									</div>
								</div>
								<div class="col-lg-3 col-md-3 col-sm-12 d-flex justify-content-center">
									<punch-in-or-out-front  v-on:childToParent="updateActivityLog"> </punch-in-or-out-front>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12" v-if="addons.includes('Roster')">
					<roster-employee-punch-card-front></roster-employee-punch-card-front>
				</div>

                <!-- Abdullah responsive added pr-md-0 -->
				<div class="row col-12 no-margin pl-md-0 custom-mobile-padding-right-zero">
					<div class="col-md-6 mb-4" v-if="addons.includes('LeaveAttendances') && company_access_settings['leave_attendances'] == true">
						<template v-if="addons.includes('LeaveAttendances') && company_access_settings['leave_attendances'] == true">
							<leave-balance-front  :is_dashboard="this.is_dashboard" v-on:childToParent="setComponent"></leave-balance-front>
						</template>
						<template v-else>
							<div class="ibox custom-box h-100 mb-0" v-if="is_dashboard == 'yes'">
								<div class="ibox-title dashboard_title">
									<div class="content-div-title">Leave Balances</div>
								</div>
								<div class="dash-ibox-content mt-3">
									N/A
								</div>
							</div>
						</template>
					</div>

					<div class="col-md-6 mb-4" v-if="addons.includes('Roster')">
						<roster-ess-summary></roster-ess-summary>
					</div>

                   	<!-- Abdullah responsive added pr-md-0 -->
					<div class="col-md-6 mb-4 pr-md-0">
						<div class="ibox custom-box h-100 mb-0">
							<div class="ibox-title dashboard_title">
								<div class="content-div-title">Calendar</div>
								<div class="ibox-content p-4">
									<v-calendar is-expanded :first-day-of-week="first_day_of_week" class='v-calendar'>
										<template slot="day-content" class='vc-w-full vc-relative' slot-scope='{day, dayEvents, attributes, attributesMap , popover}'>
											<div>
												<div v-if="weekly_holidays.includes(day.weekday)"  title="Weekend">
													<div class="flex flex-column h-100 overflow-hidden">
														<div class="day-label text-sm text-gray-900 m-1" :style="{'background-color':weekend_color_code, 'color': weekend_color_code_text}">{{ day.day }}</div>
													</div>
												</div>
												<div v-else-if="holidays_date_arr.includes(day.id)"  title="Holiday">
													<div class="flex flex-column h-100 overflow-hidden">
														<div class="day-label text-sm text-gray-900 m-1" :style="{'background-color':holiday_color_code, 'color': holiday_color_code_text}">{{day.day}}</div>
													</div>
												</div>
												<div v-else>
													<div class="flex flex-column h-100 overflow-hidden">
														<div class="day-label text-sm text-gray-900 m-1">{{day.day}}</div>
													</div>
												</div>
											</div>

										</template>
									</v-calendar>
								</div>
							</div>
						</div>
					</div>
					<template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only' && company_access_settings['payslips'] == true">

                         <!-- Abdullah responsive added pr-md-0 -->
                        <div class="col-md-6 mb-4 pr-md-0 ">

                            <!-- Abdullah 21-05-26 added mr-3  -->
							<div class="ibox custom-box h-100 mb-0 position-relative mr-3">
								<div v-if="hide_summery" class="layer-to-hide"><b-button size="lg" @click="hide_summery = false">View Summary</b-button></div>
								<div class="ibox-title dashboard_title">
									<div class="content-div-title">Payslips Summary</div>
									<div class="d-flex flex-wrap mt-3">
										<div class="mb-6 cursor-pointer" v-for="(p_month, index) in payslip_months" :key="p_month.id">
											<span class="payslip-month active px-3 py-2 mr-3 rounded" v-if="index <=2" @click="employeePayslipDataByFiscalyear(p_month.fiscal_year, p_month.month)">{{ p_month.month }} {{ p_month.year }}</span>
										</div>
									</div>
								</div>
								<div class="ibox-content">
									<div class="row no-margin mt-3">

                                        <!-- Abdullah 18-05-26 removed py-4 from here  -->
										<div class="col-md-8 col-sm-12 text-center">
											<div style="max-width: 170px; margin: 0 auto; position: relative;" v-if="doughnutDatas != null">
												<doughnut-chart :chart-data="doughnutDatas" :options= "options_doughnut" :styles="myStyles_doughnut"  class="doughnut-wrapper"></doughnut-chart>
												<span class="position-absolute" style="top: 50%; left: 0; right: 0; transform: translateY(-50%);">{{ payslip_data.month }} {{ payslip_data.year }}</span>
											</div>
										</div>
										<div class="col-md-4 col-sm-12 payslip-mobile">
											<div class="d-flex">
												<i class="fa fa-circle mr-3 grey-circle d-flex align-items-center"></i>
												<div>
													<div class="blue-text">Total Earnings</div>
													<div class="payslip-amount">BDT {{ payslip_data.total_earning }}</div>
												</div>
											</div>
											<div class="d-flex mt-2">
												<i class="fa fa-circle mr-3 sky-circle d-flex align-items-center"></i>
												<div>
													<div class="sky-text">Deductions</div>
													<div class="payslip-amount">BDT {{ payslip_data.total_deduction }}</div>
												</div>
											</div>
											<div class="d-flex mt-2">
												<i class="fa fa-circle mr-3 blue-circle d-flex align-items-center"></i>
												<div>
													<div class="blue-text">Net Pay</div>
													<div class="payslip-amount">BDT {{ payslip_data.total_net_payment }}</div>
												</div>
											</div>
										</div>
									</div>
									<div class="row no-margin mt-3" v-if="payslip_data.tax_paid_by != ''">
										<b-icon icon="info-circle-fill" class="mr-2" style="margin-top: 4px; color: #76C9D3;"></b-icon>{{payslip_data.tax_paid_by}}
									</div>
								</div>
							</div>
						</div>
					</template>
					<div class="col-md-6 d-none mb-4">
						<div class="ibox custom-box h-100 mb-0">
							<div class="ibox-title dashboard_title">
								<div class="content-div-title">Reimbursement Summary</div>
							</div>
							<div class="ibox-content position-relative px-0">
								<div class="position-absolute w-100 h-100 bg-white d-flex justify-content-center align-items-center"><h2 class="blue-text">Coming Soon!</h2></div>
								<div class="text-center reimbursement-top">
									<div class="font-semi-bold">Unclaimed Amount</div>
									<div class="cash-amount font-weight-bold my-1">BDT 5,100.00</div>
									<div class="font-semi-bold">You have an Unpaid Amount of 0.00</div>
								</div>
								<div class="font-semi-bold mt-2">Claim For June 2020</div>
								<div class="mt-1"><i class="fas fa-exclamation-circle mr-2"></i>Submit your reimbursement claims on or before 28 of this month.</div>
								<div class="text-center"><button class="dashboard-more-btn">View More</button></div>
							</div>
						</div>
					</div>
					<template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only' && company_access_settings['tax_cards'] == true">
                         <!-- Abdullah responsive added pr-md-0 -->
                        <div class="col-md-6 mb-4 pr-md-0">
							<div class="ibox h-100 position-relative">
								<div v-if="hide_tax_summery" class="layer-to-hide"><b-button size="lg" @click="hide_tax_summery = false">View Summary</b-button></div>
								<div class="ibox-title dashboard_title">
									<div class="content-div-title">Tax Summary</div>
								</div>
								<div class="ibox-content mt-2">
									<div class="row">
										<div class="col-lg-12 col-md-12 col-sm-12 mb-5">
											<div class="font-semi-bold">Total Annual Tax</div>
											<div class="cash-amount font-weight-bold my-1">BDT {{ tax_data.total_annual_tax }}</div>
											<div class="mt-4"> <i class="fas fa-exclamation-circle mr-2"></i>The remaining tax amount will be deducted as {{ tax_data.monthly_tax }}/ month in the next {{ tax_data.remaining_months }} months</div>
										</div>
										<div class="col-lg-12 col-md-12 col-sm-12">
											<div class="row tax-summary-mobile">
												<span class="percentage-box col-md-6 d-flex align-items-center">
													<span class="percentage-border left d-flex align-items-center justify-content-center">{{ tax_data.total_income_tax_paid_percetage }}%</span>Paid
												</span>
												<span class="col-md-6 d-flex align-items-center justify-content-end">
													<span class="percentage-border right d-flex align-items-center justify-content-center">{{ tax_data.total_income_tax_unpaid_percetage }}%</span>Unpaid
												</span>
											</div>
											<div>
												<span class="line-graph position-relative">
													<span class="left-portion" :style="'width:'+tax_data.total_income_tax_paid_percetage+'%;'">Paid: {{ tax_data.total_income_tax_paid }}</span>
													<span class="right-portion float-right">Unpaid: {{ tax_data.total_income_tax_unpaid }}</span>
												</span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
				<!-- start of check in checkout button -->
				<!-- <punch-in-or-out-front  v-on:childToParent="updateActivityLog"> </punch-in-or-out-front> -->
			</div>
		</div>
		<b-modal id="bv-modal-leave" hide-footer title="Apply for Leave" size="lg">
			<employee-leave-details-front  v-on:childToParent="reloadMe">
			</employee-leave-details-front>
		</b-modal>
	</div>
</template>
<script>

    import moment from 'moment';
    export default{
      mounted() {
            this.$refs.trzcalendar;
        },

        props: [ 'addons'],
        components: {
        },
        data(){

            return {
               activateKey: 0,
			   showoverlay_h:true,
			   show_data:false,
               public_info : [],
               avatarsrc : '',
               avatarsrc1 : '',
               company_avatarsrc1 : '',
               img_src : this.$api_url+'/images/employee_dasboard/',
               cr : 0,
               this_month : 1,
               this_year : 2020,
               weekly_holidays : [6,7],
               first_day_of_week : 1,
               this_month_holidays : [],
               week_holidays : [6],
               all_week_holidays : [6],
               holidays_date_arr : [],
			   report_data:[],
			   employee_info:[],
			   details:[],
               header_year_month : '',
               start_date: null,
               end_date: null,
               total_working_day : 0,
               total_weekends : 0,
               total_holidays : 0,
               total_absent : 0,
               total_leaves : 0,
               page: { month: '', year: '' },
			   company_access_settings:{},
			   payrunyears: [],
			   pf_statement_data:[],
			   year: '',
			   f_y:[],
			   statememt_available:false,
			   pf_settings :{pf_profit_waive_feature:{ opt_value: 0, status: 0 },pf_year_end:{ opt_value: 0, status: 0 },},
			   weekend_color_code : '#fff',
			   weekend_color_code_text : '#fff',
			   holiday_color_code: '#fff',
			   holiday_color_code_text : '#fff',
			   attributes: [
					{
						key: 'today',
						highlight: {
							style: {                     // Circle styles
								background: '#5533FF'
							},
							contentStyle: {              // Text styles
								color: 'white'
							},
							contentClass: 'date-text-today',
							class: 'date-circle-today',
						},
						dates: new Date(),
					}
				],


				is_dashboard: 'yes',
				payslip_data: [],
				payslip_months: [],
				tax_data: [],
				doughnutDatas: null,
                options_doughnut:null,
                myStyles_doughnut:null,
				punch_data:null,
				hide_summery: true,
				hide_tax_summery: true,
            }
        },
        methods:{
			doughnutData(basic_salary,house_rent){
                this.doughnutDatas = {
                  labels: ['Net Pay', 'Deductions'],
                  datasets: [{
                    data: [basic_salary,house_rent],
                    borderColor: ['#3A52A5','#76C9D3'], // Add custom color border
                    backgroundColor: ['#3A52A5','#76C9D3'], // Add custom color background (Points and Fill)
                    borderWidth: 4 // Specify bar border width

                  }]
                };

                 this.options_doughnut= {
                    responsive: true, // Instruct chart js to respond nicely.
                    maintainAspectRatio: true, // Add to prevent default behaviour of full-width/height
                    cutoutPercentage: 85, // Add to prevent default behaviour of full-width/height
                    legend: {
                        display: false
                    },
                    tooltips: {
						backgroundColor: '#000000',
                        callbacks: {
                            title: function(tooltipItem, data) {
                                return data['labels'][tooltipItem[0]['index']];
                            },
                            label: function(tooltipItem, data) {
								var value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
								if(parseInt(value) >= 1000){
									return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
								}else{
									return value;
								}
                            },
                        },
                    }


                };
                this.myStyles_doughnut={
                    position: 'relative',
                };
            },
			setComponent : function(x)
            {
                if(x.component_name)
                    this.setMe(x.component_name);
            },
            monthDetails: function(x='' , y=0, m=0)
            {
               let currentObj = this;
               let year = 0;
               let month = 0;

               if(y == 0)
               {
                  year = x['year'];
                  month = x['month'];
               }
               else
               {
                  year = y;
                  month = m;
               }

               let st_date = new Date(year , month - 1 , 1);
               let en_date = new Date(year , month , 0);


               this.start_date = moment(String(st_date)).format('Do MMMM YYYY');
               this.end_date = moment(String(en_date)).format('Do MMMM YYYY');



                  // fetch holidays dynamically from controller

            },
            updateActivityLog: function(data)
            {
               this.activateKey = this.activateKey+1;

            },
			getEmployeeActiveYearlist:function(employee_id)
            {

                if(!this.checkNet()) return false;

                    axios.get(this.$api_url+'/front/pf/employee-active-year-list' , {
                        params: {
                            employee_id: employee_id
                        }
                    })
                    .then(function(response){
                        this.respData = response.data;

                        if(this.respData.fiscal_year.length > 0)
                        {
                            this.payrunyears = this.respData.fiscal_year;
                            this.f_y = this.respData.year;

							if(this.pf_settings.pf_year_end.opt_value != 12)
							{
								this.year= this.payrunyears[0];
							}
							else
							{
								this.year= this.f_y[0];
							}
							this.getPFStatement(this.year);


                        }
                        else
                        {

                        }


                    }.bind(this)).catch(function (error){alert(error)});



            },



            getEmployeePublicData: function()
            {
               if(!this.checkNet()) return false;
               axios.get(this.$api_url+'/front/employee/publicinfo' , {
                  params: {

                  }
               }).then(function(response){
                  if(response.data)
                  {
                     this.company_assigned = true;
                     this.public_info = response.data;


                     if(this.public_info.pic != '')
                           this.avatarsrc = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.pic;
                     else
                           this.avatarsrc = this.$api_url+'/images/employee/demo.jpg';
                     if(this.public_info.logo != '')//at_edit
                           this.company_avatarsrc1 = this.$api_url+'/images/company/' + this.public_info.logo;//at_edit
                     else
                           this.company_avatarsrc1 = this.$api_url+'/images/company/demo.jpg';

                     if(this.public_info.report_to_pic != '')
                           this.avatarsrc1 = this.$api_url+'/images/employee/'+ this.public_info.company_id + '/' + this.public_info.logo; //at_edit
                     else
                           this.avatarsrc1 = this.$api_url+'/images/employee/demo.jpg';

                  }
                  else
                  {
                     this.company_assigned = false;
                     this.no_company_message = 'As soon as you are associated with any company, you will be able to see all data accordingly!';
                  }



               }.bind(this));

         	},
			setMe :function(x)
			{


				if(x == 'request-leave')
				this.$bvModal.show('bv-modal-leave');
				else
				{

				let childdata = {component_name:x};
				this.$emit('childToParent', childdata);
				}

			},
			reloadMe : function()
			{
				this.$bvModal.hide('bv-modal-leave');
			},
		 	get_access_settings: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/company/employee-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;

                    for (const [key, value] of Object.entries(company_access_settings_temp)) {

                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },

			getpayrunyears: function()
			{

						axios.get(this.$api_url+'/front/getpayrun-years' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunyears = response.data;

					console.log(this.payrunyears[0].range);


				}.bind(this));
			},
			getpunchData: function()
			{

						axios.get(this.$api_url+'/front/employee/attendance/get-punchedinorout' , {
							params: {

							}
					}).then(function(response){

						this.punch_data = response.data.data;

					// console.log('response.data');
					// console.log(response.data);


				}.bind(this));
			},
			get_current_fiscal_year: function()
            {
                //
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.year= response.data;
                }.bind(this));
            },
			setfiscalyear: function()
			{
				this.getPFStatement(this.year);
			},
			getPFStatement: function(year)
			{
				let currentObj = this;
				let formData = new FormData();
				formData.append('employee_id', this.employee_info.employee_id);
				formData.append('fiscal_year', year);
				formData.append('modification_flag',14);

				//currentObj.download_loader = true;

				axios.post(this.$api_url+'/front/pf/statement/download', formData)
				.then(function (response) {

						currentObj.showoverlay_h = false;
						currentObj.pf_statement_data = response.data;
						currentObj.show_data = true;

						// currentObj.download_loader = false;
						// currentObj.download_text = '';

					})
					.catch(function (error) {
						// currentObj.output = error;
						// currentObj.download_loader = false;
						// currentObj.showoverlay_h = false;

						// currentObj.download_text = '';
					});


			},
			pfDetailsNew: function()
            {

                let currentObj = this;

                let formData = new FormData();

                formData.append('viewmode', 1);
                formData.append('d_type', 'excel');
                formData.append('data_front', 'yes');
                this.pfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                //currentObj.showoverlay = true;

                axios.post(this.$api_url + '/front/downloadpfreport_custom', formData)
                                    .then(function (response)
                                    {

                                        this.employee_info = response.data.file_name.employee_info;
                                        this.details = response.data.file_name.data;
										// alert('asd');
                                        // console.log(this.employee_info);
                                        // console.log(this.details);
                                        //currentObj.showoverlay = false;
                                        this.pfoverlay = true;
										// this.getEmployeeActiveYearlist(this.employee_info.employee_id);
                                    }.bind(this))
                                    .catch(function (error)
                                    {
                                        //currentObj.showoverlay = false;
                                        console.log(error);
                                    });



                    this.$bvModal.show('bv-modal-pf-details');

            },
			formatMoney: function(amount)
            {
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }

                return money;
            },
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, '');
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
            getPFSettings: function()
            {

                let currentObj = this;
                axios.get(this.$api_url+'/front/pf/getsettings').then(function (response) {
                    currentObj.pf_settings = response.data.data;


                })
                .catch(function (error) {
                console.log(error);
                });

            },

			employeePayslipDataByFiscalyear: function(fiscal_year, month)
			{
				let currentObj = this;
				// currentObj.download_loader = true;

				axios.get(this.$api_url+'/front/get-payslip-data-ess', {
						params: {
							fiscal_year: fiscal_year,
							month: month,
						}
					}).then(function (response) {
						currentObj.payslip_data = response.data.payslips_total_data;
						currentObj.doughnutData(response.data.payslips_total_data.total_net_payment_raw, response.data.payslips_total_data.total_deduction_raw);
					})
					.catch(function (error) {
						console.log(error);
					});


			},

			getEmployeePayslipMonthsByFiscalyear: function()
			{
				let currentObj = this;
				// currentObj.download_loader = true;

				axios.get(this.$api_url+'/front/get-payslip-months', {
						params: {

						}
					}).then(function (response) {
						currentObj.payslip_months = response.data.payslips_data;
					})
					.catch(function (error) {
						console.log(error);
					});


			},
			getHoliDays:function()
            {
                axios.get(this.$api_url+'/front/company/holidays' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.holidays = response.data.holidays;

                        this.holidays_date_arr = response.data.holidays_date_arr.split(',').map(function(item){ return item;});
                    }

                }.bind(this));

            },
			getEmployeeLeaveSettings:function()
            {

                axios.get(this.$api_url+'/front/employee/leave/settings' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){

                    if(response.data.length != 0)
                    {
                        this.weekend_color_code = response.data.weekend_color_code;
                        this.holiday_color_code = response.data.holiday_color_code;
                        this.all_week_holidays = response.data.week_holidays;
                        this.week_holidays = response.data.week_holidays.split(',');
                    }

                }.bind(this));

            },

			getEmployeeTaxData: function()
			{
				let currentObj = this;
				axios.get(this.$api_url+'/front/get-tax-summary', {
					params: {

					}
				}).then(function (response) {
					currentObj.tax_data = response.data.payslips_data;
				})
				.catch(function (error) {
					console.log(error);
				});
			},

        },
        created: function(){
			this.getPFSettings();
			// this.pfDetailsNew();
            this.getEmployeePublicData();
			this.get_access_settings();
			//this.getpayrunyears();
			this.get_current_fiscal_year();
			this.getEmployeePayslipMonthsByFiscalyear();
			this.employeePayslipDataByFiscalyear('', '');
			this.getEmployeeTaxData();
			this.getpunchData();
			this.getHoliDays();
			this.getEmployeeLeaveSettings();

            // var m = check.format('M');
            // var y  = check.format('YYYY');
            // this.monthDetails('',y,m);
            // this.page = { month: m, year: y };

        },

    }

</script>
